type BaseRequest = {
  action: 'CREATE' | 'REJECT' | 'APPROVE'
}

export interface GcpCertApproval {
  name: string
  status: "PENDING_APPROVAL" | "APPROVED" | "REJECTED" | null
  approverID: string
  lastUpdatedTime: string
}

export interface GcpCertRequest extends BaseRequest {
  status: "PENDING_APPROVAL";
  requestorID: string;
  creationTime?: string;
  action: "CREATE";
  details: {
    applicationAlias: string;
    applicationName?: string;
    environment: string;
    platformName: string;
    projectId: string;
    applicationOwner: string;
    applicationOwnerEmail: string;
    wbsCode: string;
    costCenter: string;
    dnsDomainName: string;
    dnsPrefixes: string[];
    certificateType?: string;
    subnetworkName?: string;
    networkProjectId?: string;
    applicationID?: string;
    certificateViewer?: string;
  };
  approvalStatus: Array<GcpCertApproval>;
}

export interface GcpCertRejectionRequest extends BaseRequest {
  gcpCertID: string
  commenterID: string
  comment: string
  timestamp: string
  action: "REJECT" | "CREATE" | "APPROVE"
}

export interface GcpCertApprovalRequest extends BaseRequest {
  gcpCertID: string
  approverID: string
  details?: Record<string, any>
  timestamp: string
}

export type UpdateGcpCertApprovalStatus = {
  action: 'UPDATE_APPROVAL'
  gcpCertID: string
  approvalStatus?: GcpCertApproval
}

type BaseResponse = {
  status: 'PENDING_APPROVAL' | 'APPROVED' | 'REJECTED' | 'ERROR'
  creationTime: string
}

type Approval = {
  action: 'APPROVE'
  approverID: string
  details: object
  gcpCertID: string
  timestamp: string
}

export interface GcpCert extends BaseResponse {
  gcpCertID: string
  projectID?: string
  requestorID: string
  details: {
    platform: string        // required by backend
    application: string     // required by backend
    dnsPrefixes: string[]
    applicationAlias?: string
    applicationName?: string
    platformName?: string     // optional extra field from form
    [key: string]: any
  }
  version?: Record<string, any>
  comments?: any[]
  approvalStatus: Array<GcpCertApproval>
  approval?: Approval
  lastUpdatedTime: string
  creationTime: string
}

export const getGcpCertApprovalObject = (approvers: Array<string>) => {
  const approvalStatus = approvers.map((item) => {
    return {
      name: item,
      status: null,
      approverID: '',
      lastUpdatedTime: ''
    }
  })
  return approvalStatus
}
